import { StoreCategoriesDocument } from '../../queries/StoreCategories.gql'
import { useQuery } from './useQuery'

const useStoreCategories = () => {
  const queryResult = useQuery(StoreCategoriesDocument)

  return queryResult
}

export default useStoreCategories
